import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import SubNavigationLayout from '../shared/navigation/SubNavigationLayout';
import { LinkContainer } from '../shared/navigation/NavigationLinksContainer';
import LinkWithIconLeft from '../shared/common/LinkWithIconLeft';
import ShopLanguageNavigation from './ShopLanguageNavigation';
import { useTranslation } from 'react-i18next';
import { BOLINDA_ICON_ASSISTANT } from '../shared/common/Button/Icon';
import useShopLanguages from '../shared/hooks/useShopLanguages';

type Props = {
    readonly isSticky: boolean;
};

const ShopNavigation: FC<Props> = ({ isSticky }) => {
    const { t } = useTranslation();
    const { path } = useRouteMatch();
    const shopLanguages = useShopLanguages();

    return (
        <Switch>
            <Route exact path={`${path}/featured`}>
                <SubNavigationLayout
                    center={
                        <LinkContainer>
                            {shopLanguages.map(({ shopLanguageId, shopLanguageName }) => (
                                <li key={shopLanguageId}>
                                    <LinkWithIconLeft to={`/shop/${shopLanguageId}`}>
                                        <span>
                                            {t(`menu.shop.shopLanguages.${shopLanguageId}`, {
                                                defaultValue: shopLanguageName
                                            })}
                                        </span>
                                    </LinkWithIconLeft>
                                </li>
                            ))}
                            <li>
                                <LinkWithIconLeft to="/shop/other">
                                    <span>
                                        {shopLanguages.length === 1 && shopLanguages[0].shopLanguageId === 'en'
                                            ? t('menu.shop.shopLanguages.lote')
                                            : t('menu.shop.shopLanguages.other')}
                                    </span>
                                </LinkWithIconLeft>
                            </li>
                            <li>
                                <LinkWithIconLeft to="/shop/all">
                                    <span>{t('menu.shop.shopLanguages.all')}</span>
                                </LinkWithIconLeft>
                            </li>
                            <li>
                                <LinkWithIconLeft to="/assistant" theme="warning">
                                    <i className="bolinda-icons" aria-hidden={true}>
                                        {BOLINDA_ICON_ASSISTANT}
                                    </i>
                                    <span>{t('menu.shop.orderingAssistantMain')}</span>
                                </LinkWithIconLeft>
                            </li>
                        </LinkContainer>
                    }
                    isSticky={isSticky}
                    width="15"
                />
            </Route>
            <Route path={`${path}/:shopLanguage`}>
                <ShopLanguageNavigation isSticky={isSticky} />
            </Route>
        </Switch>
    );
};

ShopNavigation.displayName = 'ShopNavigation';

export default ShopNavigation;
